export default "__VITE_ASSET__q97wrcpZ__"